import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'px-login-forgot-confirmed',
    templateUrl: './login.forgot.confirm.component.html',
    styleUrls: ['./login.forgot.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class LoginForgotConfirmComponent implements OnInit {
  countDown!: number;
  email!: string;
  constructor(private router: Router) { }

  ngOnInit(): void {
    this.countDown = 5;
    this.StartCountDown();
  }

  StartCountDown(): void {
    window.setInterval(() => {
      this.countDown -= 1;
      if (this.countDown === 0) {
        this.router.navigate(['login']);
      }
    }, 1000);
  }

  OnBackBtnClick(): void {
    this.router.navigate(['login']);
  }
}